import { useRef } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '@store/hooks';
import { selectAuth, selectIsAuthenticated } from '@store/slices/auth';
import { authLog } from '@utils/authLog';

export function RequireAuth() {
  const { initializing } = useAppSelector(selectAuth);
  const isAuthed = useAppSelector(selectIsAuthenticated);
  const location = useLocation();

  // Log only when the decision changes — not on every render — so the trace
  // stays signal-rich.
  const lastDecision = useRef<string | null>(null);
  const decision = initializing ? 'wait' : isAuthed ? 'render' : 'redirect';
  if (lastDecision.current !== decision) {
    lastDecision.current = decision;
    authLog('guard-decision', {
      decision,
      initializing,
      isAuthed,
      path: location.pathname,
    });
  }

  // <BootSplash> in AppRoutes covers the viewport while initializing — render
  // nothing here so we don't double-show a loader.
  if (initializing) return null;

  if (!isAuthed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
